const API_BASE = "https://ecom-elevate-email-server.vercel.app/send-email";

export const sendEmail = async (formData) => {
  const res = await fetch(API_BASE, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name: formData.name,
      email: formData.email,
      phone: formData.contactNumber,
      message: formData.message,
      country: formData.country,
      source: "Ecomlevate.com",
    }),
  });
  
  let data = {};
  try {
    data = await res.json();
  } catch {
    // ignore parse error; data stays {}
  }

  if (!res.ok) {
    // Prefer server-sent message if available
    throw new Error(data.message || "Failed to send email");
  }

  return data;
};
